<h1 mat-dialog-title>{{headline}}</h1>
<mat-dialog-content>
    <p>{{materials?.length || 0}} Material{{ materials?.length === 1 ? '' : 'ien'}} bestätigt</p>
    <p *ngIf="ledgerimportsCreated$ | async">{{warehouseMovementTypeLabel}} erfolgreich angelegt</p>
    <ng-container *ngIf="commissionsWithMaterials.length">
        <p>{{cls.getMultiple$('Commission') | async}}:</p>
        <ul>
            <ng-container *ngFor="let commission of commissionsWithMaterials">
                <li><strong>{{(commission.commission$ | async)?.DisplayName}}</strong> ({{commission.materials.length}} Material{{ commission.materials.length === 1 ? '' : 'ien'}})</li>
            </ng-container>
        </ul>
    </ng-container>
    <mat-form-field class="w-full" *ngIf="!allMaterialsHaveCommissionId">
        <ng-container *ngFor="let group of materialsWithoutCommissionIdGrouped">
            <mat-form-field class="w-full">
                <mat-label>
                    {{ cls.getSingle$('Commission') | async }}
                    für {{ group.materials.length }} Material{{ group.materials.length === 1 ? '' : 'ien' }}
                    ({{ group.commissionAuftragsNummer }})
                </mat-label>

                <app-select-search
                    [initialSearch]="group.commissionAuftragsNummer"
                    [disabled]="ledgerimportsCreated$ | async"
                    [formControl]="commissionForms[group.commissionAuftragsNummer]"
                    [Options]="commissionOptions$ | async"
                    [CompareOptions]="compareById">
                </app-select-search>
            </mat-form-field>
        </ng-container>

<!--        <mat-label>{{cls.getSingle$('Commission') | async}} {{commissionsWithMaterials.length ? (' für die übrigen ' + materialsWithoutCommissionId.length + ' Materialien') : ''}}</mat-label>-->
<!--        <app-select-search [disabled]="ledgerimportsCreated$ | async" [formControl]="commissionForm" [Options]="commissionOptions$ | async" [CompareOptions]="compareById"></app-select-search>-->
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-between gap-4">
    <button app-button Inverted Color="cancel" mat-dialog-close="">abbrechen</button>
    <button app-button Color="green" [IsLoading]="ls.IsLoading$ | async" [Disabled]="!materials || !materials.length" *ngIf="!(ledgerimportsCreated$ | async)" (click)="submit()">  {{ getButtonText() }}</button>
    <button app-button Color="green" [IsLoading]="ls.IsLoading$ | async" [mat-dialog-close]="{created: true, routeToDeliveryNote: false}" *ngIf="ledgerimportsCreated$ | async">Fertig</button>
</mat-dialog-actions>
